import { render, staticRenderFns } from "./selectDic.vue?vue&type=template&id=c994f3ec&scoped=true&"
import script from "./selectDic.vue?vue&type=script&lang=js&"
export * from "./selectDic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c994f3ec",
  null
  
)

export default component.exports